{
  "send_to": "Send to",
  "apple": "Apple Calendar",
  "google": "Google Calendar",
  "outlook": "Outlook.com",
  "office": "Office 365",
  "other": "Other calendar",
  "link_copied": "Link copied",
  "paste_into_google": "Paste into <1>Google <2 /></1> to setup"
}
